import { Link } from "react-router-dom";
import { useAppointment } from "../../../context/AppointmentContext";

const ButtonsSection = ({ scrollToForm }) => {
  const { openAppointment } = useAppointment();

  return (
    <div className="container">
      <section className="buttons-section py-2">
        <div className="buttons-container">

          {/* Book Appointment */}
          <button
            className="pink-btn"
            data-sal="slide-up"
            data-sal-duration="1000"
            onClick={() => openAppointment("Buttons Section")}
          >
            <i className="fa-solid fa-calendar-check me-2"></i>
            Book Appointment
          </button>

          {/* Find Doctor */}
          <Link
            to="/doctorslist"
            className="gray-btn"
            data-sal="slide-up"
            data-sal-duration="1000"
            data-sal-delay="100"
          >
            <i className="fa-solid fa-user-doctor me-2"></i>
            Find a Doctor
          </Link>

          {/* Emergency */}
          <a
            href="tel:+919994288800"
            className="pink-btn"
            data-sal="slide-up"
            data-sal-duration="1000"
            data-sal-delay="200"
          >
            <i className="fa-solid fa-calendar-check me-2"></i>
            Emergency care
          </a>

        </div>
      </section>
    </div>
  );
};

export default ButtonsSection;
